import { FormGroup, FormSection, Spinner, TextInput } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { useFormContext } from '@frontend/utils/hooks/useFormContext';
import type { OrderSuppliesFormState } from '../../types/orderSuppliesFormState';

interface OrderSuppliesPracticeDataProps {
    isLoading: boolean;
}

export function OrderSuppliesPracticeData({ isLoading }: OrderSuppliesPracticeDataProps) {
    const translate = getSelectedLanguage();
    const form = useFormContext<OrderSuppliesFormState>();

    return (
        <FormSection
            action={isLoading && <Spinner />}
            title={translate.patient.practiceData}
        >
            <FormGroup
                isRequired={true}
                label={translate.patient.practiceName}
            >
                <TextInput
                    disabled={form.isSubmitting || isLoading}
                    error={form.errors.getMessage('practice.organizationName')}
                    name="practice.organizationName"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.practice.organizationName ?? ''}
                />
            </FormGroup>
            <FormGroup
                isRequired={true}
                label={translate.organization.streetName}
            >
                <TextInput
                    disabled={form.isSubmitting || isLoading}
                    error={form.errors.getMessage('practice.street')}
                    name="practice.street"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.practice.street ?? ''}
                />
            </FormGroup>
            <FormGroup
                isRequired={true}
                label={translate.common.houseNumber}
            >
                <TextInput
                    disabled={form.isSubmitting || isLoading}
                    error={form.errors.getMessage('practice.houseNumber')}
                    name="practice.houseNumber"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.practice.houseNumber ?? ''}
                />
            </FormGroup>
            <FormGroup label={translate.common.houseNumberSuffix}>
                <TextInput
                    disabled={form.isSubmitting || isLoading}
                    error={form.errors.getMessage('practice.houseNumberSuffix')}
                    name="practice.houseNumberSuffix"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.practice.houseNumberSuffix ?? ''}
                />
            </FormGroup>
            <FormGroup
                isRequired={true}
                label={translate.common.zipcode}
            >
                <TextInput
                    disabled={form.isSubmitting || isLoading}
                    error={form.errors.getMessage('practice.zipCode')}
                    name="practice.zipCode"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.practice.zipCode ?? ''}
                />
            </FormGroup>
            <FormGroup
                isRequired={true}
                label={translate.common.city}
            >
                <TextInput
                    disabled={form.isSubmitting || isLoading}
                    error={form.errors.getMessage('practice.city')}
                    name="practice.city"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.practice.city ?? ''}
                />
            </FormGroup>
        </FormSection>
    );
}
